import { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import lodash from 'lodash';

import {
    addApplicationHeaderTitle
} from 'common/actions/applicationHeader';

import {
    loadSdfaSentItem,
    clearSdfaItem,
    cancelSdfaTask,
} from 'forms/actions/sdfa';

import LoadingComponent from 'common/permissions/components/LoadingComponent';
import {
    SubFormRouter,
    SubFormRoute
} from 'forms/containers/SubFormRouter/SubFormRouter';
import { manageTasksSelector, documentTypePermissionsSelector } from 'common/permissions/selectors';
import WorkflowDocumentViewer from 'workflow/containers/WorkflowDocumentViewer';
import SdfaSentItem from 'forms/components/Sdfa/SentItem/SentItem';

export class SdfaWorkflowSummary extends Component {

    componentDidMount() {
        const { loadSdfaSentItem, workflowId, binderId, userHasPermission, } = this.props;
        loadSdfaSentItem(workflowId, userHasPermission, binderId);
    }

    componentWillUnmount() {
        this.props.clearSdfaItem();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pageTitle === null && nextProps.sentItem) {
            this.props.addApplicationHeaderTitle(nextProps.sentItem.title);
        }
    }

    viewDocument() {
        const { push, location } = this.props;
        const updatedLocation = lodash.cloneDeep(location);
        updatedLocation.query.subformroute = 'viewDocument';
        push(updatedLocation);
    }

    render() {
        const {
            sentItem,
            workflowId,
            cancelSdfaTask,
            viewDocumentPermission,
        } = this.props;

        if (lodash.isNull(sentItem)) {
            return <LoadingComponent />;
        }

        return (
            <SubFormRouter data-cy="SdfaWorkflowSummary">
                <SubFormRoute>
                    <SdfaSentItem
                        sentItem={sentItem}
                        cancelTask={cancelSdfaTask}
                        viewDocumentPermission = {viewDocumentPermission}
                        viewDocument={this.viewDocument.bind(this)} />
                </SubFormRoute>

                <SubFormRoute query="viewDocument">
                    <WorkflowDocumentViewer
                        workflowId={workflowId}
                        shouldShowFullViewer={true} />
                </SubFormRoute>
            </SubFormRouter>
        );
    }
}

export default connect(
    (state, props) => {
        const binderId = lodash.get(props, 'location.query.binderId', null);
        const binderInstitutionId = lodash.get(props, 'location.query.iid', null);
        const documentTypeId = lodash.get(state, 'form.sentItem.document.documentType.id', null);
        const userHasPermission = (manageTasksSelector(state, binderInstitutionId) && !lodash.isNil(binderId));
        const viewDocumentPermission = documentTypePermissionsSelector(state, documentTypeId);
        return {
            binderId,
            userHasPermission,
            workflowId: lodash.get(props, 'location.query.workflowId', null),
            sentItem: lodash.get(state, 'form.sentItem', null),
            pageTitle: lodash.get(state, 'app.pageTitle', null),
            location: props.location,
            viewDocumentPermission,
        };
    }, {
        loadSdfaSentItem,
        clearSdfaItem,
        addApplicationHeaderTitle,
        cancelSdfaTask,
        push
    }
)(SdfaWorkflowSummary);
